import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getLine = (lineId: number | undefined): Promise<IGetLineViaID> => {
  return axiosDefaultApi.get(`/api/ComLines/GetComLineViaID/DataLine/${lineId}`);
};

type QueryFnType = typeof getLine;

type UseGetLineOptions = {
  lineId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLine = ({ lineId , config }: UseGetLineOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getLine_${lineId}`],
    queryFn: () => getLine(lineId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Γραμμής Data.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};